import { render, staticRenderFns } from "./ServiceFee.vue?vue&type=template&id=2080a0bc&scoped=true&"
import script from "./ServiceFee.vue?vue&type=script&lang=js&"
export * from "./ServiceFee.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFee.vue?vue&type=style&index=0&id=2080a0bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2080a0bc",
  null
  
)

export default component.exports